//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Layer.js";
SPLM.Layer.StateInfo = class{
    constructor(layer,state){
        this.layer=layer;this.state=state;}
    get Layer(){return this.layer}
    set Layer(val){this.layer = val}
    get State(){return this.state}
    set State(val){this.state = val}
};

SPLM.Layer.Constants = Object.freeze({
    "FirstLayer" : "FirstLayer", "LastLayer" : "LastLayer"});

SPLM.Layer.State = Object.freeze({
    "WorkLayer" : "WorkLayer", "Selectable" : "Selectable", "Visible" : "Visible", "Hidden" : "Hidden"});

export default SPLM;